import { useState } from 'react'

import { OrderCarrierRequestsDialog } from '#/features/carrier-requests'
import type { ShipmentDetail } from '#/shared/api/generated/shipment/models'
import { RequestsButton } from '#/widgets/detail-toolbar'

import { shouldShowCarrierRequests } from '../lib/carrier-requests-visibility'
import { SHIPMENT_STAGES } from '../model/stages'
import type { ShipmentStage } from '../model/stages'

interface ShipmentRequestsSlotProps {
  stage: ShipmentStage
  shipment?: ShipmentDetail
}

export function ShipmentRequestsSlot({
  stage,
  shipment,
}: ShipmentRequestsSlotProps) {
  const [open, setOpen] = useState(false)
  if (stage !== SHIPMENT_STAGES.ORDER) return null
  if (!shouldShowCarrierRequests(shipment)) return null
  const count = shipment?.carrier_requests_count ?? 0
  return (
    <>
      <RequestsButton count={count} onClick={() => setOpen(true)} />
      <OrderCarrierRequestsDialog
        shipmentId={shipment?.id}
        open={open}
        onOpenChange={setOpen}
      />
    </>
  )
}
